module.exports = require('react/lib/ReactTransitionGroup');


//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/react-smooth/~/react-addons-transition-group/index.js
// module id = 666
// module chunks = 0